
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
        import herramientas from './carga-herramientas.vue';
        import finalizar from './carga-finalizar.vue';
        import lista from './lista-listado.vue';

import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {
    herramientas,
    finalizar,
    lista,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Estado() { return this.Controlador.Vista.Estado; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {

            await Wait( 500 );
            this.Panel = 0;

            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( () =>
            {
                //if ( this.Estado == 'iniciado' )


            } ) )
        }

        public Panel: number = null;
        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
